import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Routers from "./components/Routes";
import i18n from "./i18n";
import { getUserDataRequest } from "./modules/user/Actions";

function App() {
  const dispatch = useDispatch();
  const token = window.localStorage.getItem("token");
  
  useEffect(() => {
    if (token) dispatch(getUserDataRequest());
  }, [token]);

  // Global right-click prevention (desktop only)
  useEffect(() => {
    // Check if device is mobile/touch
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                    ('ontouchstart' in window) || 
                    (navigator.maxTouchPoints > 0);

    // Only prevent right-click on desktop devices
    if (!isMobile) {
      const preventMouseDown = (e) => {
        if (e.button === 2) { // Right mouse button
          e.preventDefault();
          return false;
        }
      };

      const preventContextMenu = (e) => {
        e.preventDefault();
        return false;
      };

      // Add event listeners to document
      document.addEventListener('mousedown', preventMouseDown);
      document.addEventListener('contextmenu', preventContextMenu);

      // Cleanup function to remove event listeners
      return () => {
        document.removeEventListener('mousedown', preventMouseDown);
        document.removeEventListener('contextmenu', preventContextMenu);
      };
    }
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routers />
    </I18nextProvider>
  );
}

export default App;
